import React from "react";
import styles from "./styles.css";
import withStyles from "../../with-styles/with-styles";
import Dialog from "components/dialog";
import ShakaPlayerComponent from "../../shaka-player/ShakaPlayerComponent";
import VideoPosterDefault from "static/images/video-poster-default.png";
/*import Player from "@cinfo/tiivii-embedded-player/components/player/player";*/

const PlayerDialog = ({classes, intl, handleClose, open, clip}) => {
    const ref = React.useRef(null);
    return (
        <Dialog
            title={intl.formatMessage({id: "recording.player"})}
            open={open}
            onClose={handleClose}>
            <div className={classes.videoContainer}>
                <ShakaPlayerComponent  ref={ref} autoPlay src={clip.url} poster={VideoPosterDefault}/>
            </div>
            {/*<Player fileUrl={clip.url}/>*/}
        </Dialog>
    )
};

export default withStyles(styles)(PlayerDialog);